import {
  PostPagePostFragment,
  PostStatusEnum,
} from "@/generated/generated-hooks";

export const validatePost = (post: PostPagePostFragment) =>
  post &&
  !!post.writer &&
  !!post.channel &&
  !!post.previewImage &&
  post.postStatus !== PostStatusEnum.Removed;
